export default __webpack_public_path__ + "static/media/warning_tick.932e7154.svg";